import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
class InvoiceAutoCare {
  create = async (invoice: any) => {
    const res = await axios({
      method: "post",
      url: `${API_URL}invoice-autocare`,
      data: invoice,
    }).catch((e) => {
      const { message } = e.response.data;
      if (message.errorInfo) throw message.errorInfo[2];
      else throw e.message;
    });
    return res.data;
  };
  edit = async (invoice: any, code: any) => {
    const res = await axios({
      method: "put",
      url: `${API_URL}invoice-autocare/${code}`,
      data: invoice,
    }).catch((e) => {
      const { message } = e.response.data;
      if (message.errorInfo) throw message.errorInfo[2];
      else throw e.message;
    });
    return res.data;
  };
  getPrevInvoice = async (code: any) => {
    const response = await axios({
      method: "get",
      url: `${API_URL}invoice-autocare/${code}`,
    }).catch((e) => {
      throw e.message;
    });
    return response.data.invoice;
  };
  get = async (code: any) => {
    const response = await axios({
      method: "get",
      url: `${API_URL}invoice-autocare/${code}`,
    }).catch((e) => {
      throw e.message;
    });
    return response.data;
  };
  getAll = async () => {
    const response = await axios({
      method: "get",
      url: `${API_URL}invoice-autocare`,
    }).catch((e) => {
      throw e.message;
    });
    return response.data.invoice;
  };
  getLastThree = async (key: any) => {
    const response = await axios({
      method: "get",
      url: `${API_URL}recent-invoice-autocare/${key ? key : 0}`,
    }).catch((e) => {
      throw e.message;
    });
    return response.data.invoice;
  };
  search = async (keyword: any) => {
    const response = await axios({
      method: "get",
      url: `${API_URL}invoice-invoice-autocare/${keyword}`,
    }).catch((e) => {
      throw e.message;
    });
    return response.data.invoice;
  };
  customerOutstanding = async (keyword: any) => {
    const response = await axios({
      method: "get",
      url: `${API_URL}invoice-autocare-outstanding-customer/${keyword}`,
    }).catch((e) => {
      throw e.message;
    });
    return response.data.invoices;
  };
}
export default new InvoiceAutoCare();
